import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';

import { apiContainer } from './api/api.module';
import { coreContainer } from './core/ioc';

export const rootContainer = Container.merge(apiContainer, coreContainer);

export const { lazyInject } = getDecorators(rootContainer);
